import { WINE_STATUS, type WineStatus } from '@wineryxplorer/shared';
import { FormSection } from '../ui/FormSection';

export interface WineManagementFieldsProps {
  status: WineStatus;
  onStatusChange: (value: WineStatus) => void;
  isSubmitting: boolean;
}

export const WineManagementFields = ({
  status,
  onStatusChange,
  isSubmitting,
}: WineManagementFieldsProps) => (
  <FormSection title="Management">
    {/* Status */}
    <div>
      <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">
        Status <span className="text-red-500">*</span>
      </label>
      <select
        id="status"
        value={status}
        onChange={(e) => onStatusChange(e.target.value as WineStatus)}
        disabled={isSubmitting}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500 ${
          isSubmitting ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      >
        {WINE_STATUS.map((statusOption) => (
          <option key={statusOption} value={statusOption}>
            {statusOption.charAt(0).toUpperCase() + statusOption.slice(1)}
          </option>
        ))}
      </select>
      <p className="mt-1 text-sm text-gray-500">
        Draft wines are only visible to venue admins. Published wines are visible to everyone.
      </p>
    </div>
  </FormSection>
);
